import { render } from "./templateNotification.vue?vue&type=template&id=be66755c"
import script from "./templateNotification.vue?vue&type=script&lang=js"
export * from "./templateNotification.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__